import { render } from "./CVEDetail.vue?vue&type=template&id=6a141d0e&scoped=true"
import script from "./CVEDetail.vue?vue&type=script&lang=js"
export * from "./CVEDetail.vue?vue&type=script&lang=js"

import "./CVEDetail.vue?vue&type=style&index=0&id=6a141d0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a141d0e"]])

export default __exports__